import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod, OpenApiParameterType } from '../../open-api.method';
import { config } from '../../../config';
import { CartConstantsControllerGetResponse } from '../../responses/cart-constants-controller-get.response';

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/cart-constants',
  operationId: 'CartConstantsController_get',
  parameters: [
    {
      name: 'tenantId',
      required: true,
      in: OpenApiParameterType.QUERY,
    },
  ],
})
export class CartConstantsControllerGetMethod
  extends BaseOpenApiMethod<CartConstantsControllerGetResponse>
  implements Method<CartConstantsControllerGetResponse, void>
{
  public call(): Promise<CartConstantsControllerGetResponse> {
    return super.call({
      parameters: {
        tenantId: config.tenantId,
      },
    });
  }
}
